// Max email length as defined by RFC 5321.
const MAX_EMAIL_LENGTH = 254;

/**
 * Validates an email address.
 *
 * Pattern: domain labels must
 * start and end with an alphanumeric character, hyphens are only allowed inside
 * a label, and consecutive/leading/trailing dots are rejected. A trailing dot
 * (TLD) is required.
 */
export const EMAIL_REGEXP =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export const isValidEmail = (email?: string | null): boolean =>
  !!email && email.length <= MAX_EMAIL_LENGTH && EMAIL_REGEXP.test(email);

export const hasNonAsciiChar = (value?: string | null): boolean =>
  !!value && value.split('').some((char) => char.charCodeAt(0) > 127);
